import { createContext, useCallback, useMemo } from 'react'

interface ICopilotContext {
  setAssemblyId: (id: string) => void
}

export const CopilotContext = createContext<ICopilotContext>({
  setAssemblyId: () => {},
})

interface CopilotProviderProps {
  children?: React.ReactNode
}

export function CopilotProvider({ children }: CopilotProviderProps) {

  const setAssemblyId = useCallback((id: string) => {
    window.assemblyCopilot?.setAssemblyId(id)
  }, [])

  const value = useMemo(
    () => ({
      setAssemblyId,
    }),
    [setAssemblyId]
  )

  return (
    <CopilotContext.Provider value={value}>{children}</CopilotContext.Provider>
  )
}
